import RdPublication from './RdPublication';
export default class PublicationsSection {
    static fromPartial(partial) {
        var _a, _b;
        const publicationSection = new PublicationsSection();
        const translation = (_a = partial.translations) === null || _a === void 0 ? void 0 : _a[0];
        publicationSection.title = (_b = translation === null || translation === void 0 ? void 0 : translation.title) !== null && _b !== void 0 ? _b : '';
        if (partial.publications) {
            publicationSection.publications = new Array();
            for (const publication of partial.publications) {
                if (publication === null || publication === void 0 ? void 0 : publication.rd_publication_id)
                    publicationSection.publications.push(RdPublication.fromPartial(publication.rd_publication_id));
            }
        }
        return publicationSection;
    }
}
